import { Card, Flex, Group, Text } from '@mantine/core'
import { LineChart } from '@ospace/leads-dashboard'
import { MoreInfo } from '@ospace/shared'
import { Icon } from '@tabler/icons-react'

import classes from './LineGraphCard.module.css'
import { SideBySideFigures } from './SideBySideFigures'

// const useStyles = ({
//   backgroundColor,
//   iconBackgroundColor,
// }: {
//   backgroundColor: string
//   iconBackgroundColor: string
// }) =>
//   createStyles(() => ({
//     card: {
//       backgroundColor: backgroundColor,
//       color: 'white',
//     },
//     icon: {
//       padding: 6,
//       borderRadius: 6,
//       backgroundColor: iconBackgroundColor,
//       color: 'white',
//     },
//     textSmall: {
//       fontSize: 12,
//     },
//     textLarge: {
//       fontSize: 30,
//     },
//     detailedCard: {
//       fontSize: '18px',
//       height: '500px',
//     },
//     bar: {
//       borderLeft: '6px solid #0CA678',
//     },
//     value: {
//       fontSize: 30,
//     },
//   }))

export const LineGraphCard = ({
  icon: Icon,
  heading,
  title,
  tooltip,
  data,
  chartLabels,
  right,
  left,
  backgroundColor,
  iconBackgroundColor,
}: {
  backgroundColor: string
  iconBackgroundColor: string
  icon: Icon
  heading: string
  title: string
  tooltip?: string
  data?: { x: string; y: number }[]
  chartLabels?: { leftLabel: string; rightLabel: string }
  left: { label: string; value: string | number | JSX.Element }
  right: { label: string; value: string | number | JSX.Element }
}) => {
  return (
    <Card
      className={classes.card}
      style={{
        backgroundColor: backgroundColor,
      }}
      withBorder
      shadow='sm'
      padding='lg'
      radius='md'
    >
      <Group>
        <div className={classes.icon} style={{ backgroundColor: iconBackgroundColor }}>
          <Icon />
        </div>
        <Text fw={700}>{heading}</Text>
      </Group>
      <Group mt='lg' justify='left'>
        <Text tt='uppercase' fw={600} fz='md'>
          {title}
        </Text>
        {tooltip && <MoreInfo info={tooltip} iconColor='white' />}
      </Group>
      <SideBySideFigures
        labelColor='white'
        left={left}
        right={right}
        style={{ marginTop: '0.5rem' }}
      />
      {data && chartLabels && (
        <>
          <LineChart
            data={[
              {
                id: 'pipeline',
                color: 'white',
                data,
              },
            ]}
            enableArea={true}
          />
          <Group justify='space-between'>
            <Flex justify={`flex-start`}>{chartLabels.leftLabel}</Flex>
            <Flex justify={`flex-start`}>{chartLabels.rightLabel}</Flex>
          </Group>
        </>
      )}
    </Card>
  )
}
